export let timeZone = 'America/New_York';
export function setZone(zone: string) {
  timeZone = zone;
}
